import { render, staticRenderFns } from "./verificationCode.vue?vue&type=template&id=790f8c2a&scoped=true"
import script from "./verificationCode.vue?vue&type=script&lang=ts"
export * from "./verificationCode.vue?vue&type=script&lang=ts"
import style0 from "./verificationCode.vue?vue&type=style&index=0&id=790f8c2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790f8c2a",
  null
  
)

export default component.exports